// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"product-filter-buttons_wrapper__y27Q9","button":"product-filter-buttons_button__pjLCy","filtersOpenButton":"product-filter-buttons_filtersOpenButton__Pa3WQ"};